import { Breadcrumbs, Stack, Typography } from '@mui/material';

import SlashForwardIcon from '@/components/Icons/SlashForwardIcon';
import Meta from '@/components/Meta';
import useIsMultipleTeamsEnabled from '@/hooks/useIsMultipleTeamsEnabled';
import GlobalHeader from '@/sections/GlobalHeader';
import Sidebar from '@/sections/Sidebar';
import { useWorkspaceSection } from '@/sections/Sidebar/hooks';
import TeamMenu from '@/sections/Teams/TeamMenu';

import Chains from './Chains';
import ModelAPIs from './ModelAPIs';
import Models from './Models';
import Overview from './Overview';
import Training from './Training';
import { WorkspaceSections } from './types';
import { mapSectionToTitle } from './utils';

const workspaceSectionComponents = {
  [WorkspaceSections.Models]: Models,
  [WorkspaceSections.ModelAPIs]: ModelAPIs,
  [WorkspaceSections.Chains]: Chains,
  [WorkspaceSections.Training]: Training,
  [WorkspaceSections.Overview]: Overview,
};

function Workspace() {
  const section = useWorkspaceSection();
  const isMultipleTeamsEnabled = useIsMultipleTeamsEnabled();

  function getContent() {
    const SectionComponent = workspaceSectionComponents[section];

    return (
      <Stack direction="row" overflow="hidden" height="100%" flex={1}>
        <Stack overflow="auto" flex={1} height="100%">
          <SectionComponent />
        </Stack>
      </Stack>
    );
  }

  return (
    <Meta title={`${mapSectionToTitle[section]} | Baseten`}>
      <Stack direction="row" height="100%" width="100%">
        <Sidebar />
        <Stack
          sx={{
            height: '100%',
            width: '100%',
            overflow: 'auto',
          }}
        >
          <GlobalHeader
            title={
              <Breadcrumbs
                separator={
                  <SlashForwardIcon sx={{ color: (theme) => theme.palette.secondary.light }} />
                }
              >
                {section !== WorkspaceSections.Overview && isMultipleTeamsEnabled && <TeamMenu />}
                <Typography variant="h5" color="text.default">
                  {mapSectionToTitle[section as keyof typeof mapSectionToTitle]}
                </Typography>
              </Breadcrumbs>
            }
            sx={{
              pl: 4,
            }}
          />
          {getContent()}
        </Stack>
      </Stack>
    </Meta>
  );
}

export default Workspace;
